import React from 'react';
export function Masthead() {
  return <header className="border-b border-gray-200" data-id="element-90">
      {/* Top bar */}
      <div className="border-b border-gray-100 py-2 px-6" data-id="element-91">
        <div className="max-w-5xl mx-auto flex items-center justify-between text-xs text-gray-500" data-id="element-92">
          <span className="uppercase tracking-wide" data-id="element-93">Health</span>
          <span data-id="element-94">Subscribe · Newsletter · About</span>
        </div>
      </div>

      {/* Main masthead */}
      <div className="py-6 px-6" data-id="element-95">
        <div className="max-w-5xl mx-auto" data-id="element-96">
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-center" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-97">
            Fermata Wellbeing
          </h1>
          <p className="text-center text-xs text-gray-500 mt-2 uppercase tracking-widest" data-id="element-98">
            Evidence-Based Living
          </p>
        </div>
      </div>
    </header>;
}